import type {
  UnicoCreateProcessResponse,
  UnicoDocumentProcessResponse
} from "@repo/core/services/entities/Unico";

interface ShouldRetryUnicoCaptureParams {
  processData: UnicoCreateProcessResponse;
  documentData?: Partial<UnicoDocumentProcessResponse> | null;
  requiresBiometry: boolean;
  requiresIdentityDocument: boolean;
}

export const hasUnicoSelfieArtifact = (
  processData?: Partial<UnicoCreateProcessResponse> | null
): boolean => {
  return Boolean(processData?.selfie?.fileContents?.trim());
};

export const hasUnicoDocumentArtifact = (
  documentData?: Partial<UnicoDocumentProcessResponse> | null
): boolean => {
  return Boolean(
    documentData?.documentFrontBase64?.trim() ||
      documentData?.documentBackBase64?.trim() ||
      documentData?.fullDocumentBase64?.trim()
  );
};

export const shouldRetryUnicoCaptureForMissingArtifacts = ({
  processData,
  documentData,
  requiresBiometry,
  requiresIdentityDocument
}: ShouldRetryUnicoCaptureParams): boolean => {
  if (!requiresBiometry) {
    return false;
  }

  const hasSelfie = hasUnicoSelfieArtifact(processData);

  if (!requiresIdentityDocument) {
    return !hasSelfie;
  }

  return !hasSelfie && !hasUnicoDocumentArtifact(documentData);
};
